import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { EXPAND_ARROW, COLLAPSE_ARROW } from '../../../utils/trackingLinks';
import Destination from './Destination';
import TrackingLink from './TrackingLink';
import ArchiveIcon from '../../../resources/svg/archive_grey.svg';
import Icon, { IconSizes, IconTypes } from '../../foundations/Icon';

const Campaign = ({
    app_id = null,
    campaign = '',
    campaign_id = '',
    css = {},
    deleteClicked = {},
    data = {},
    editClicked = {},
    editCampaignName = {},
    editingCampaign = '',
    expanded = false,
    toggleExpand = {},
}) => {
    const editInput = useRef(null);

    const adjustWidthOfInput = () => {
        const inputElement = document.getElementById('editInputField');
        inputElement.size = Math.max(18, inputElement.value.length + 3);
    };

    const firstItem = data.platforms[Object.keys(data.platforms)[0]];
    return (
        <div className={css.CampaignPanel}>
            <div className={css.CampaignHeading}>
                <div
                    className={`${css.CampaignName} ${css.Expand}`}
                    onClick={() => {
                        toggleExpand(campaign_id);
                    }}
                >
                    {expanded ? COLLAPSE_ARROW : EXPAND_ARROW}
                </div>
                <div
                    className={`${css.CampaignName} ${css.TextWrapper}`}
                    onClick={() => {
                        toggleExpand(campaign_id);
                    }}
                >
                    {data.platforms.iOS && (
                        <Icon
                            name="apple-fill"
                            type={IconTypes.MINGCUTE}
                            size={IconSizes.MEDIUM}
                            style={{ marginRight: '5px', color: '#CCCCCC' }}
                        />
                    )}
                    {data.platforms.Android && (
                        <Icon
                            name="android-2-fill"
                            type={IconTypes.MINGCUTE}
                            size={IconSizes.MEDIUM}
                            style={{ marginRight: '5px', color: '#CCCCCC' }}
                        />
                    )}
                    {editingCampaign === campaign_id ? (
                        <input
                            autoFocus
                            type="text"
                            defaultValue={campaign}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    editCampaignName(app_id, e);
                                } else if (e.key === 'Escape') {
                                    editClicked(undefined);
                                } else {
                                    adjustWidthOfInput();
                                }
                            }}
                            id="editInputField"
                            ref={editInput}
                            onBlur={() => {
                                editClicked(undefined);
                            }}
                            size={Math.max(18, campaign.length + 3)}
                            onClick={e => e.stopPropagation()}
                            onKeyUp={adjustWidthOfInput}
                            style={{
                                height: '20px',
                                fontSize: '16px',
                                marginBottom: '5px',
                            }}
                        />
                    ) : (
                        <span className={css.CampaignNameLabel}>{campaign}</span>
                    )}
                    {firstItem.singular_link ? (
                        <span className={css.CampaignNameSingularLinkLabel}>(Singular Link)</span>
                    ) : null}
                    {!firstItem.singular_link ? (
                        <React.Fragment>
                            <span
                                className={css.deleteButton}
                                style={{
                                    borderRight: '1px solid #a3a3a3',
                                    paddingRight: '10px',
                                    paddingLeft: '10px',
                                    marginTop: '4px',
                                    fontSize: '12px',
                                    color: '#a3a3a3',
                                }}
                                onClick={e => {
                                    e.stopPropagation();
                                    if (editingCampaign === campaign_id) {
                                        editClicked(undefined);
                                    } else {
                                        editClicked(campaign_id);
                                    }
                                }}
                            >
                                <Icon
                                    name={editingCampaign === campaign_id ? 'close-fill' : 'pencil-line'}
                                    style={{ color: '#a3a3a3' }}
                                    size={IconSizes.X_SMALL}
                                    type={IconTypes.MINGCUTE}
                                />
                            </span>
                            <span
                                className={css.deleteButton}
                                onClick={e => {
                                    e.stopPropagation();
                                    deleteClicked(campaign_id);
                                }}
                                style={{ paddingLeft: '10px', verticalAlign: 'top' }}
                            >
                                <ArchiveIcon
                                    style={{
                                        height: '15px',
                                        width: '15px',
                                        marginTop: '3px',
                                    }}
                                />
                            </span>
                        </React.Fragment>
                    ) : null}
                </div>
            </div>
            {expanded && (
                <div>
                    <div className={css.DestinationPanel}>
                        <div className={css.DestinationHeading}>Destinations</div>
                        <div className={css.DestinationTable}>
                            <div>
                                {Object.keys(data.platforms)
                                    .sort()
                                    .map(platform => (
                                        <Destination
                                            key={`${campaign}_destination_${platform}`}
                                            css={css}
                                            destination={data.platforms[platform].destination}
                                            platform={platform}
                                            link={data.platforms[platform]}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className={css.DestinationPanel}>
                        <div className={css.DestinationHeading}>Tracking Links</div>
                        <div className={css.DestinationTable}>
                            <TrackingLink css={css} data={firstItem} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

Campaign.propTypes = {
    app_id: PropTypes.number,
    campaign: PropTypes.string,
    campaign_id: PropTypes.string,
    css: PropTypes.objectOf(PropTypes.any),
    deleteClicked: PropTypes.func,
    data: PropTypes.objectOf(PropTypes.any),
    editClicked: PropTypes.func,
    editCampaignName: PropTypes.func,
    editingCampaign: PropTypes.string,
    expanded: PropTypes.bool,
    toggleExpand: PropTypes.func,
};

export default Campaign;
